import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '../../../queryClient'
import {DashboardOpsResponse, httpGetDashboardOps, HttpGetDashboardOpsOptions} from '../http/dashboard.http'

export const useGetDashboardOps = (
    params: HttpGetDashboardOpsOptions['params'],
    options?: UseQueryOptions<DashboardOpsResponse>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.DASHBOARD_OPS, params],
        queryFn: () => httpGetDashboardOps({params}),
        ...options
    })
}
